import { create } from "zustand";

interface SlotTimingState {
  genesisTime: number | null;
  slotDuration: number | null;
  setTiming: (genesisTime: number, slotDuration: number) => void;
}

export const useSlotTiming = create<SlotTimingState>()((set) => ({
  genesisTime: null,
  slotDuration: null,
  setTiming: (genesisTime, slotDuration) => set({ genesisTime, slotDuration }),
}));
